<script lang="ts">
export type WorkflowScope = 'all' | 'myClient' | 'assigned'

export interface WorkflowScopeItem {
  label: string
  value: WorkflowScope
  icon?: string
}
</script>

<script setup lang="ts">
defineProps<{
  scope: WorkflowScope
  items: WorkflowScopeItem[]
}>()

const emit = defineEmits<{
  (e: 'update:scope', value: WorkflowScope): void
}>()

const handleUpdate = (value: string | number) => {
  emit('update:scope', value as WorkflowScope)
}
</script>

<template>
  <UTabs
      :model-value="scope"
      :items="items"
      size="sm"
      class="w-fit"
      :content="false"
      :ui="{ trigger: 'data-[state=active]:text-white cursor-pointer' }"
      @update:model-value="handleUpdate"
  />
</template>
